const config = {
  AUTH: {
    PLACEHOLDER: {
      RUT: 'Run: XXXXXXXX-X',
      PASSPORT: 'Pasaporte: AV948332'
    },
    LABEL: {
      RUT: 'Número de run',
      PASSPORT: 'Número de pasaporte'
    },
    ROLES: {
      SUPERADMIN: 'SUPER_ADMIN_ROLE',
      ADMIN: 'ADMIN_ROLE',
      STANDART: 'STANDART_ROLE'
    }
  },
  FORM: {
    PATTERN: {
      NUMBER: /^[0-9]*$/i,
      EMAIL: /^[a-zA-Z0-9.-_-\-]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}$/i,
      RUT: {
        EXP: /^\d{1,2}\d{1,3}\d{3}[-][0-9kK]{1}$/i,
        MAXLENGHT: 10
      },
      PASSPORT: {
        EXP: /^(?!^0+$)[a-zA-Z0-9]{6,15}$/i, // /^[A-Z][0-9]{8}$/i,
        MAXLENGHT: 15
      },
      PHONE: {
        EXP: /^[0-9]{9}$/i,
        MINLENGHT: 9,
        MAXLENGHT: 9
      },
      PASSWORD: {
        EXP: /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/,
        MINLENGHT: 8
      },
      DOCUMENTNUMBER: {
        EXP: /^[0-9A-Za-z]{6,11}$/,
        MINLENGHT: 6,
        MAXLENGHT: 11
      }
    }
  },
  ROUTES: {
    HOME: '/',
    AUTH: {
      REGISTER: {
        HOME: '/registrar',
        RUT: '/registrar/run',
        PASSPORT: '/registrar/pasaporte'
      },
      FORGOTPASSWORD: '/olvido-contrasena'
    },
    ADMIN: {
      HOME: '/admin',
      USERS: {
        HOME: '/admin/usuarios',
        CREATE: {
          MAIN: '/admin/usuarios/crear',
          PATIENT: '/admin/usuarios/crear/paciente',
          ADMIN: '/admin/usuarios/crear/admin'
        },
        EDIT: '/admin/usuarios/editar'
      },
      ALERTS: '/admin/alerts',
      CONTROLPREVENTION: {
        HOME: '/admin/control-prevencion',
        CREATE: '/admin/control-prevencion/crear',
        EDIT: '/admin/control-prevencion/editar'
      },
      FORGOTPASSWORD: '/admin/olvido-contrasena',
      MAILING: '/admin/mailing',
      ADS: {
        HOME: '/admin/anuncios',
        CREATE: '/admin/anuncios/crear',
        EDIT: '/admin/anuncios/editar'
      },
      FAMILY: {
        HOME: '/admin/familia',
        ADDMEMBER: '/admin/familia/agregar-integrante'
      }
    },
    DASHBOARD: {
      HOME: '/dashboard',
      PROFILE: '/dashboard/perfil',
      MEDICALAPPOINTMENTS: {
        HOME: '/dashboard/consultas-medicas',
        PASTHOURS: '/dashboard/consultas-medicas/horas-pasadas',
        REQUESTDOCUMENTS: '/dashboard/consultas-medicas/solicitar-documento'
      },
      FAMILYGROUP: {
        HOME: '/dashboard/mi-grupo-familiar',
        ADDMEMBER: '/dashboard/mi-grupo-familiar/agregar-integrante'
      },
      REQUESTS: '/dashboard/solicitudes',
      CONTACT: '/dashboard/contactanos',
      BUDGETREQUEST: '/dashboard/solicitud-presupuestos',
      EXAMSPROCEDURES: {
        HOME: '/dashboard/mis-examenes',
        LABORATORY: '/dashboard/mis-examenes/laboratorio',
        OTHEREXAMS: '/dashboard/mis-examenes/otros-examenes',
        DISPLAYDURATION: '/dashboard/mis-examenes/plazos-visualizacion'
      },
      CONTROLPREVENTION: '/dashboard/control-prevencion',
      SCHEDULE: '/dashboard/agenda'
    }
  },
  APPOINTMENT_CONTACT: '293,294,295,296,297,298,301,302,303,304,305,307,308,309,310,311,312,313,314,315,317,318,319,320,324,325,326,327,328,329,330,331,332,333,334,336,337,338,339,340,342,343,344,345,347,348,349,350,351',
  MESSAGE: {
    REGISTER: {
      SOLEM_ERROR: 'No fue posible validar tu identidad, puedes volver a intentarlo o acercarte a la Clínica para completar tu proceso de registro. Te esperamos en Servicio al Cliente ubicado en la Torre A piso 2.',
      PASSPORT_ALERT: 'Te encuentras registrado con pasaporte. Para visualizar tus exámenes debes ingresar con RUN Chileno. Si ya cuentas con tu RUN, recuerda hacer el cambio del tipo de documento en Servicio al Cliente.'
    },
    BROWSER_ALERT: 'Para una mejor experiencia en Mi Portal INDISA sugerimos utilizar Google Chrome.',
    EXAM: {
      LABORATORY_ALERT: 'Para visualizar tus exámenes de imagenología y procedimientos, debes ingresar a Mi Portal INDISA con tu número de Run o retirarlos presencialmente.'
    }
  },

  APP: {
    API_URL: (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : ''),
    SOLEM_URL: (process.env.REACT_APP_SOLEM_URL ? process.env.REACT_APP_SOLEM_URL : ''),
    SOLEM_URL_COMP: (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'prod' ? '' : '/appv3/'),
    EXAM_IFRAME_URL: (process.env.REACT_APP_EXAM_IFRAME_URL ? process.env.REACT_APP_EXAM_IFRAME_URL : ''),
    ENV: (process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : ''),
    API_SCHEDULE_URL: (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'prod' ? 'https://ng-backend.indisa.cl/' : 'https://cing-backend.indisa.cl/'),
  }
}

export default config